import { FloatingInput, type FloatingInputProps } from "@/components/ui/floating-input";
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";
import { useState } from "react";

/**
 * Password input with the legacy eye toggle (old
 * `components/form/input-password`): a 24px visibility icon at 70% opacity,
 * inside the field, that flips the input between `password` and `text`.
 */
export function PasswordField(props: Omit<FloatingInputProps, "type" | "trailingIcon">) {
  const [visible, setVisible] = useState(false);
  return (
    <FloatingInput
      {...props}
      type={visible ? "text" : "password"}
      trailingIcon={
        <button
          type="button"
          aria-label="Show password"
          aria-pressed={visible}
          className="flex items-center opacity-70 transition-opacity hover:opacity-100"
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? (
            <MdOutlineVisibilityOff size={24} aria-hidden />
          ) : (
            <MdOutlineVisibility size={24} aria-hidden />
          )}
        </button>
      }
    />
  );
}
